function getRecommendButton(
  htReview = { isRecommended: false, recommendCnt: 0, isDisplay: true }
) {
  return `<button type="button" data-role="recommend" class="btn_review_thumbs ${
    htReview.isRecommended === true ? 'on' : ''
  }" ${htReview.isDisplay === false ? 'disabled' : ''}>
            ${
              TMON.sDevice === 'PW'
                ? '<svg width="12px" height="14px" viewBox="0 0 12 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="ico_recommend"><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="ico_recommend_off"><g><rect id="area" x="0" y="0" width="12" height="14"></rect><path d="M4,12 L1.707,12 C1.31666667,12 1,11.6833333 1,11.293 L1,5.707 C1,5.31666667 1.31666667,5 1.707,5 L4,5 L4,12 Z" id="Stroke-1" stroke="#6C7580"></path><path d="M9.09090909,5.4 L7.45577273,5.4 C7.37177273,5.4 7.32468182,5.31011429 7.36763636,5.23845714 C7.61295455,4.82925714 7.81818182,3.76665714 7.81818182,3.51428571 L7.81818182,2.88571429 C7.81818182,2.57142857 7.5,1 6.54545455,1 C5.27272727,1 5.27272727,2.88571429 5.27272727,2.88571429 L5.27272727,3.51428571 C5.27272727,4.45714286 4,5.4 4,5.4 L4,10.4285714 C4,11.2963143 4.71209091,12 5.59090909,12 L8.45454545,12 C9.86027273,12 11,10.8742286 11,9.48571429 L11,7.28571429 C11,6.24448571 10.1450455,5.4 9.09090909,5.4 Z" id="Stroke-3" stroke="#6C7580" stroke-linecap="round" stroke-linejoin="round"></path></g></g></g></svg>'
                : '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="21" viewBox="0 0 18 21" class="ico_recommend_big"><g fill="none" fill-rule="evenodd">&gt;<path stroke="#6C7580" d="M6 18H2.56a1.06 1.06 0 0 1-1.06-1.06V8.56c0-.585.475-1.06 1.06-1.06H6V18z"></path><path stroke="#6C7580" stroke-linecap="round" stroke-linejoin="round" d="M13.636 8.1h-2.452c-.126 0-.197-.135-.133-.242.368-.614.676-2.208.676-2.587V4.33c0-.472-.477-2.829-1.909-2.829C7.91 1.5 7.91 4.329 7.91 4.329v.942C7.91 6.686 6 8.1 6 8.1v7.543C6 16.944 7.068 18 8.386 18h4.296c2.108 0 3.818-1.689 3.818-3.771v-3.3c0-1.562-1.282-2.829-2.864-2.829z"></path></g></svg>'
            }
            <span class="text">${
              htReview.recommendCnt ? htReview.recommendCnt : 0
            }${htReview.recommendCnt > 998 ? '+' : ''}</span>
        </button>`;
}

/**
 * 구매 딜 및 옵션 정보 영역 HTML을 반환
 */
const getRenderHtml = (aData, htRefinedDealInfo) =>
  `<div data-role="reviewMain" class="photoreview_pop" style="display:none">
        ${
          TMON.sDevice === 'PW'
            ? `<div class="photoreview_header">
                <h4>포토리뷰 상세보기</h4>
                <button type="button" data-role="close" class="btn_close">
                    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" class="ico_btn_close"><path fill="#6C7580" fill-rule="evenodd" d="M22.281 0L23 .719 12.218 11.5 23 22.281l-.719.719L11.5 12.218.719 23 0 22.281 10.781 11.5 0 .719.719 0 11.5 10.782 22.281 0z"></path></svg>
                    <span class="blind">닫기</span>
                </button>
            </div>`
            : ''
        }
        <div data-role="reviewWrap" class="_reviewWrap swiper-container-p">
            <div class="swiper-wrapper" data-role="reviewContainer"></div>
        </div>
        ${
          TMON.sDevice === 'PW'
            ? `<button type="button" data-role="prevReview" class="btn_arrow_prev" aria-label="이전 슬라이드" style="${
                aData.length <= 1 ? 'display:none' : ''
              }"><svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" class="ico_prev_arrow"><g fill="none" fill-rule="evenodd"><path fill="#16181a" fill-rule="nonzero" d="M35 12.676L34.31 12 19 27l15.31 15 .69-.676L20.38 27z"></path></g></svg></button>
            <button type="button" data-role="nextReview" class="btn_arrow_next" aria-label="다음 슬라이드" style="${
              aData.length <= 1 ? 'display:none' : ''
            }"><svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" class="ico_next_arrow"><g fill="none" fill-rule="evenodd"><path fill="#16181a" fill-rule="nonzero" d="M19 41.324l.69.676L35 27 19.69 12l-.69.676L33.62 27z"></path></g></svg></button>`
            : ''
        }
        <div id="review-recommend-button" class="_reviewRecommend">${
          TMON.sDevice !== 'PW' ? getRecommendButton({}) : ''
        }</div>
        <div class="section_fixed">${
          /* 하단 딜영역 */
          htRefinedDealInfo
            ? `<div class="review_deal_area">
                <div class="fig">
                    <div class="thumb" style="background-image:url(${
                      htRefinedDealInfo.sImage
                    })"></div>
                </div>
                <div class="info">
                    <strong class="title_name">${
                      htRefinedDealInfo.sTitle
                    }</strong>
                    <div class="price_area">
                        ${htRefinedDealInfo.sPriceTypeHtml}
                        <span class="price">
                            <span class="num">${
                              htRefinedDealInfo.sPrice
                            }</span>원
                            ${htRefinedDealInfo.sPriceOver}
                        </span>
                        ${
                          htRefinedDealInfo.sOrgPrice
                            ? `<span class="original_price">
                                <span class="blind">원가</span>
                                <span class="num">${htRefinedDealInfo.sOrgPrice}</span>원
                            </span>`
                            : ''
                        }
                    </div>
                </div>
                <a href="${htRefinedDealInfo.sUrl}"
                    data-role="dealLink"
                    data-title="${htRefinedDealInfo.sTitle}"
                    data-dealNo="${htRefinedDealInfo.nDealNo}"
                    class="review_deal_link"
                    ${TMON.sDevice === 'PW' ? 'target="blank"' : ''}></a>
            </div>`
            : ''
        }</div>
        <div data-role="review_toast" class="review_toast_recommend" style="display:none;">
            <p class="text">추천해주셔서 감사합니다.</p>
        </div>
    </div>`;

function getSingleReivewHtml(htReview) {
  return `<div class="photoreview_wrap review_detail">
            <h1 class="review_write_title">리뷰 상세보기</h1>
            <div class="review_image_wrap" style="${
              htReview.hasImage === true &&
              htReview.imageInfo &&
              htReview.imageInfo.image
                ? ''
                : 'display:none'
            }">
                <div class="photo_detail_area">
                    ${
                      htReview.hasImage === true &&
                      htReview.imageInfo &&
                      htReview.imageInfo.image
                        ? `<div class="photo_container">
                                <div class="swiper-container-c">
                                    <ul class="photo_list swiper-wrapper">${htReview.imageInfo.image
                                      .map(
                                        (sImage, nIndex) =>
                                          `<li class="photo_item swiper-slide ${
                                            nIndex === 0 ? 'show' : ''
                                          }">
                                                <img data-role="mainImage" src="${sImage}" alt="사용자가 업로드한 제품 사진입니다." onError="$(this).remove();">
                                                <div class="no_img">
                                                    <span class="blind">이미지없음</span>
                                                </div>
                                            </li>`
                                      )
                                      .join('')}</ul>
                                </div>
                            </div>`
                        : ''
                    }
                    ${
                      TMON.sDevice !== 'PW'
                        ? /* 사진 카운트 (모바일) */
                          `<div class="info" ${
                            htReview.hasImage === true &&
                            htReview.imageInfo &&
                            htReview.imageInfo.image.length > 1
                              ? ''
                              : 'style="display:none"'
                          }>
                            <div class="swiper-pagination" style="display:none;">
                                <span class="swiper-pagination-current"></span>
                                <span class="swiper-pagination-total"></span>
                            </div>
                            <span class="cnt" style="${
                              TMON.sDevice !== 'PW'
                                ? 'position:static;bottom:14px;z-index:20;left:50%;transform:translateX(-50%);-webkit-transform:translate(-50%);'
                                : ''
                            }">
                                <span data-role="pageNationCurrent" class="cnt_current">1</span> / <span class="cnt_total">${
                                  htReview.hasImage === true &&
                                  htReview.imageInfo
                                    ? htReview.imageInfo.image.length
                                    : 0
                                }</span>
                            </span>
                        </div>`
                        : ''
                    }
                </div>
            </div>
            <div class="photoreview_content">
                <div class="photo_add_area ${
                  htReview.isDisplay === false ? 'disabled' : ''
                }" style="display: ${
    this.bShowAddPhotoBtn === true &&
    htReview.hasImage === false &&
    htReview.isOwner === true
      ? 'block'
      : 'none'
  }">
                    <div class="photo_add_thumb"></div>
                    <div class="photo_add_text">
                        <strong class="photo_add_title">이미지 등록하기</strong>
                    </div>
                    <a data-role="addPhoto" href="#none" class="photo_add_link
                        ${htReview.isDisplay === false ? 'disabled' : ''}"></a>
                </div>
                <div class="photoreview_box scroll">
                    <div class="photoreview_rate_box">
                        <div class="photoreview_rate">
                            <div class="photoreview_star">
                                <span class="text">상품</span>
                                <span class="star_rate">
                                    <span class="star_progress_bar" style="width: ${(htReview.dealGpoint *
                                      100) /
                                      5}%;">
                                        <span class="blind">상품 평점 ${
                                          htReview.dealGpoint
                                        }</span>
                                    </span>
                                </span>
                            </div>
                            ${
                              htReview.deliveryGpoint !== 0
                                ? `<div class="photoreview_star">
                                    <span class="text">배송</span>
                                    <span class="star_rate">
                                        <span class="star_progress_bar" style="width: ${(htReview.deliveryGpoint *
                                          100) /
                                          5}%;">
                                            <span class="blind">배송 평점 ${
                                              htReview.deliveryGpoint
                                            }점</span>
                                        </span>
                                    </span>
                                </div>`
                                : ''
                            }
                        </div>
                        <div class="review_tag">${
                          /* 태그 */
                          htReview.reviewSurveyList &&
                          htReview.reviewSurveyList.length > 0
                            ? htReview.reviewSurveyList.map(
                                reviewSurveyListItem =>
                                  `<span class="review_tag_label">#${reviewSurveyListItem.keyword} - ${reviewSurveyListItem.selection}</span>`
                              )
                            : ''
                        }</div>
                    </div>
                    ${
                      /* 구매옵션 // NOTE */
                      htReview.optionDealInfo
                        ? `${
                            htReview.optionDealInfo.optionDealInfoList.length >=
                            2
                              ? // <!--[D] 옵션이 두개 이상 노출될 경우 .button_list_bind 옵션 리스트  활성화시 on 추가-->
                                `<div class="button_list_box" data-role="openOptionWrap">
                                    <span class="blind">상품 옵션</span>
                                    <div class="options_box">
                                        <button data-role="openOptionBtn" type="button" class="button_list" aria-label="옵션 딜 더보기">
                                            <span class="text">${
                                              htReview.optionDealInfo
                                                .optionDealInfoList[0].title
                                            }</span>
                                            <svg width="11px" height="6px" viewBox="0 0 11 6" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="ico_arrow"><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="btn_open" fill="#B7BFC8" fill-rule="nonzero"><polygon transform="translate(5.500000, 3.000000) rotate(-180.000000) translate(-5.500000, -3.000000) " points="5.5 1.4 0.723 6 0 5.3 4.777 0.7 5.5 0 11 5.3 10.277 6"></polygon></g></g></svg>
                                        </button>
                                        <div class="button_list_bind">${htReview.optionDealInfo.optionDealInfoList
                                          .map((htOption, idx) => {
                                            if (idx === 0) {
                                              return '';
                                            }

                                            return `<span class="button_list_text">${htOption.title}</span>`;
                                          })
                                          .join('')}</div>
                                    </div>
                                </div>`
                              : `<div class="button_list_box" data-role="openOptionWrap">
                                    <span class="blind">상품 옵션</span>
                                    <div class="options_box">
                                        <div class="button_list">
                                            <span class="text">${htReview.optionDealInfo.optionDealInfoList[0].title}</span>
                                        </div>
                                    </div>
                                </div>`
                          }`
                        : ''
                    }
                    <div class="photoreview_text">${
                      // 리뷰 내용
                      htReview.contents.replace(/\n/g, '<br>')
                    }</div>
                </div>
                <div class="photoreview_box2">
                    <div class="photoreview_image" style="${
                      htReview.hasImage === true &&
                      htReview.imageInfo &&
                      htReview.imageInfo.image.length > 1
                        ? ''
                        : 'display:none'
                    }">
                        <ul class="review_image_list">${
                          htReview.hasImage === true && htReview.imageInfo
                            ? htReview.imageInfo.image
                                .map(
                                  (sImage, nIndex) =>
                                    `<li data-role="photoOver" class="review_image_item ${
                                      /* [D] 선택된 영역에 on 클래스 추가 */ nIndex ===
                                      0
                                        ? 'on'
                                        : ''
                                    }" data-image="${sImage}">
                                    <button type="button" class="review_image_box" aria-label="이미지 상세보기">
                                        <img src="http://storage.tmon.co.kr/thumbs/image?w=300&h=300&url=${sImage}" onerror="this.parentNode.className='review_image_box error'">
                                    </button>
                                </li>`
                                )
                                .join('')
                            : ''
                        }</ul>
                    </div>
                    <ul class="type_bar_list">
                        <li class="type_bar_item">${htReview.whoCreate}</li>
                        <li class="type_bar_item">${htReview.createDt
                          .substring(0, 10)
                          .replace(
                            /-/g,
                            '.'
                          )} <span class="type_bar_text">작성</span></li>
                        ${
                          htReview.isOwner === false
                            ? '<li class="type_bar_item"><button type="button" data-role="report" class="btn_type_bar">신고</button></li>'
                            : ''
                        }
                    </ul>
                    ${TMON.sDevice === 'PW' ? getRecommendButton(htReview) : ''}
                </div>
                <div class="review_btn_wrap">
                    ${
                      htReview.isOwner === true &&
                      this.bShowModifyButtons === true
                        ? `<button data-role="deletePhotoReview" type="button" class="review_btn delete">삭제</button>
                        <button data-role="modifyPhotoReview" type="button" class="review_btn edit"
                            ${
                              htReview.isDisplay === false ? 'disabled' : ''
                            }>수정</button>`
                        : ''
                    }
                    <div class="review_notice_wrap">
                        <p class="review_notice" style="display:${
                          htReview.isOwner === false ||
                          htReview.isDisplay === false
                            ? 'none'
                            : 'block'
                        }">
                            리뷰 내용에 대한 책임은 작성자에게 있으며,<br>
                            등록된 내용은 상품 판매/홍보 메뉴에 노출될 수 있습니다.
                        </p>
                        <p class="review_notice alert" style="display:${
                          htReview.isOwner === true &&
                          htReview.isDisplay === false
                            ? 'block'
                            : 'none'
                        }">
                            이 리뷰는 신고에 의해 비공개처리 되었습니다.<br>
                            비공개 리뷰는 수정이 불가능합니다.
                        </p>
                    </div>
                </div>
            </div>
        </div>`;
}

export { getRenderHtml, getSingleReivewHtml };
